import React from "react";
import { Check } from "lucide-react";
import { useI18n } from "../i18n";
import { useSeo } from "../hooks/useSeo";
import { pathFor } from "../config/site";
import { webpageLd, breadcrumbLd } from "../lib/jsonld";
import PageHero from "../components/PageHero";
import { Section } from "../components/Section";

export default function DisclaimerPage({ pageKey }) {
  const { lang, d } = useI18n();
  const meta = d.meta.disclaimer;
  useSeo({
    pageKey,
    title: meta.title,
    description: meta.description,
    jsonLd: [
      webpageLd({ lang, pageKey, title: meta.title, description: meta.description }),
      breadcrumbLd([
        { name: d.ui.nav.home, path: pathFor(lang, "home") },
        { name: d.ui.nav.disclaimer, path: pathFor(lang, "disclaimer") },
      ]),
    ],
  });

  return (
    <>
      <PageHero testid="disclaimer-hero" title={d.pages.disclaimer.heading} intro={d.pages.disclaimer.intro} />
      <Section>
        <div className="max-w-3xl">
          <p className="text-lg text-jlo-warm/85 leading-relaxed">{d.disclaimer.long}</p>
          <ul className="mt-8 space-y-4" data-testid="disclaimer-points">
            {d.pages.disclaimer.points.map((pt, i) => (
              <li key={i} className="flex gap-3">
                <Check className="h-5 w-5 text-jlo-gold shrink-0 mt-0.5" aria-hidden="true" />
                <span className="text-base text-jlo-warm/80 leading-relaxed">{pt}</span>
              </li>
            ))}
          </ul>
        </div>
      </Section>
    </>
  );
}
